/**
 * Updates :forPreviewMenu and :forFebAdmin
 * @param {*} htmlContent
 * @param {*} appUser
 * @returns
 */
export function applyPreviewClass (htmlContent, appUser) {
  const isUserAllowed = appUser?.email?.includes('florian')
  const hasUserEnabled = appUser?.isPreviewEnabled

  if (!isUserAllowed || !hasUserEnabled) {
    // console.log('hide preview')
    // Admin demo menu
    htmlContent = htmlContent.replaceAll(':forPreviewMenu', 'is-hidden')
  } else {
    htmlContent = htmlContent.replaceAll(':forPreviewMenu', '')
  }

  if (!isUserAllowed) {
    // console.log('hide preview')
    // Admin demo menu
    htmlContent = htmlContent.replaceAll(':forFebAdmin', 'is-hidden')
  } else {
    htmlContent = htmlContent.replaceAll(':forFebAdmin', '')
  }
  return htmlContent
}
